export default __webpack_public_path__ + "static/media/CSIO_2021_Annual_Report.1a671671.pdf";